<template>
  <Form :value="formValues" :schema="schema" @submit="handleSubmit">
    <template #default="{ submit, submitting, ...formParams }">
      <form class="border p-3 rounded mt-3" @submit.prevent="submit">
        <div class="flex text-gray-900">
          <h2 class="flex flex-1 font-medium items-center leading-4 text-lg">
            <slot>Adapter Type</slot>
          </h2>

          <div class="flex">
            <a href="#" @click.prevent="expanded = !expanded">
              <ChevronUpIcon v-if="expanded" class="h-5 w-5 fill-current" />
              <ChevronDownIcon v-else class="h-5 w-5 fill-current" />
            </a>
          </div>
        </div>

        <template v-if="expanded">
          <Field
            v-for="field in fields"
            v-bind="formParams"
            :key="field._id"
            :prefix="prefix"
            :field="field"
            class="mt-3"
          />

          <Field
            v-for="field in adapterTypeFields"
            v-bind="formParams"
            :prefix="adapterTypePrefix"
            :key="field._id"
            :field="field"
            class="mt-3"
          />

          <div class="mt-3 flex justify-end">
            <Button
              status="primary"
              type="submit"
              :loading="submitting"
              :disabled="submitting"
            >
              Next
            </Button>
          </div>
        </template>
      </form>
    </template>
  </Form>
</template>

<script>
import { defineComponent } from "vue";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/vue/solid";
import Field from "@/components/common/Field";
import form from "@/mixins/form";
import fields from "@/mixins/fields";

export default defineComponent({
  mixins: [form, fields],
  emits: ["submit"],

  components: {
    Field,
    ChevronUpIcon,
    ChevronDownIcon,
  },

  props: {
    prefix: String,
    fields: Array,
    values: Object,
    typeId: String,
    adapterId: String,
    submitted: Boolean,
    adapterTypePrefix: String,
    adapterTypeFields: Array,
  },

  computed: {
    schema() {
      return this.createSchema(this.adapterTypeFields, this.prefix);
    },
    formValues() {
      return this.createFieldValues(this.adapterTypeFields, this.values, this.prefix);
    },
  },

  data() {
    return {
      expanded: true,
    };
  },

  methods: {
    async handleSubmit({ values, setSubmitting, setSubmitted }) {
      setSubmitting();
      try {
        const { data: validated } = await this.$axios.post(
          `/adapters/${this.adapterId}/types/${this.typeId}/fields`,
          values
        );

        if (validated.data.success) {
          this.$emit("submit", values);
        }

        setSubmitted();
      } catch (error) {
        setSubmitted();
      }
    },
  },

  watch: {
    submitted(value) {
      if (value) {
        this.expanded = false;
      }
    },
  },
});
</script>
